export default {"src":"/_next/static/media/window-sliding.ffabcfef.svg","height":1000,"width":1000};